import React, { useEffect, useState, useRef, useCallback } from 'react';
import './App.css';
import windowsIcon from './Windowslogo.png';
import terminalIcon from './Terminallogo.png';
import phantomIcon from './Phantomlogo.png';
import phanomAppImg from './Phantomapp.png';
import emptyPhanomAppImg from './Emptyphantomapp.png';
import homeAppImg from './Homeapp.png';
import telegramLogo from './Telegramlogo.png';
import infoIcon from './Xlogo.png';
import solscanLogo from './Solscanlogo.png';
import dexscreenerLogo from './Dexscreenerlogo.jpg';
import dextoolsLogo from './Dextoolslogo.png';
import bonkLogo from './Bonklogo.png';
import rickGif from './Rickgif.gif';
import oriVexLogo from './OriVex.png';
import flashGif from './Flash.gif';
import phantomAudio from './Phantomaudio.mp3'; // Use your actual filename


function Clock() {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  // Windows 11 clock format: 24-hour time above, date below
  const timeString = time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
  const dateString = time.toLocaleDateString([], { month: '2-digit', day: '2-digit', year: 'numeric' });

  return (
    <div className="clock">
      <div className="clock-time">{timeString}</div>
      <div className="clock-date">{dateString}</div>
    </div>
  );
}

function Terminal({ onClose }) {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState([
    "Solana Virus Web Terminal",
    "Type 'ca' for SolanaVirus Contract Address."
  ]);

  // --- Draggable logic start ---
  const modalRef = useRef(null);
  const [position, setPosition] = useState({ x: window.innerWidth/2 - 200, y: window.innerHeight/2 - 150 });
  const [dragging, setDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  const handleMouseDown = (e) => {
    setDragging(true);
    setOffset({
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    });
  };

  const handleTouchStart = (e) => {
    setDragging(true);
    const touch = e.touches[0];
    setOffset({
      x: touch.clientX - position.x,
      y: touch.clientY - position.y,
    });
  };

  const handleMouseMove = useCallback((e) => {
    if (dragging) {
      setPosition({
        x: e.clientX - offset.x,
        y: e.clientY - offset.y,
      });
    }
  }, [dragging, offset]);

  const handleTouchMove = useCallback((e) => {
    if (dragging) {
      const touch = e.touches[0];
      setPosition({
        x: touch.clientX - offset.x,
        y: touch.clientY - offset.y,
      });
    }
  }, [dragging, offset]);

  const handleMouseUp = () => setDragging(false);
  const handleTouchEnd = () => setDragging(false);

  useEffect(() => {
    if (dragging) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
      window.addEventListener('touchmove', handleTouchMove);
      window.addEventListener('touchend', handleTouchEnd);
    } else {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
      window.removeEventListener('touchmove', handleTouchMove);
      window.removeEventListener('touchend', handleTouchEnd);
    }
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
      window.removeEventListener('touchmove', handleTouchMove);
      window.removeEventListener('touchend', handleTouchEnd);
    };
  }, [dragging, offset, handleMouseMove, handleTouchMove]);
  // --- Draggable logic end ---

  const handleInput = (e) => setInput(e.target.value);

  const handleSubmit = (e) => {
    e.preventDefault();
    const command = input.trim();
    let response = "";

    switch (command) {
      case "ca":
        response = "Contract Address: "; // Example address
        break;
      case "date":
        response = new Date().toString();
        break;
      case "clear":
        setOutput([]);
        setInput('');
        return;
      default:
        if (command.startsWith("echo ")) {
          response = command.slice(5);
        } else if (command === "") {
          response = "";
        } else {
          response = `Command not found: ${command}`;
        }
    }

    setOutput([...output, `> ${command}`, response]);
    setInput('');
  };

  return (
    <div
      className="terminal-modal"
      ref={modalRef}
      style={{
        left: position.x,
        top: position.y,
        transform: 'none',
        position: 'fixed',
        width: '30vw', // Increased by 0.5%
      }}
    >
      <div className="terminal-titlebar" onMouseDown={handleMouseDown} onTouchStart={handleTouchStart} style={{ cursor: 'move', touchAction: 'none' }}>
        <span className="terminal-title">Web Terminal</span>
        <button className="terminal-close" onClick={onClose}>×</button>
      </div>
      <div className="terminal-output">
        {output.map((line, i) => <div key={i}>{line}</div>)}
      </div>
      <form onSubmit={handleSubmit}>
        <span style={{color: "#0f0"}}>&gt; </span>
        <input
          className="terminal-input"
          value={input}
          onChange={handleInput}
          autoFocus
        />
      </form>
    </div>
  );
}

function PhantomApp({ onClose }) {
  const modalRef = useRef(null);
  const [position, setPosition] = useState({ x: window.innerWidth/2 - 200, y: window.innerHeight/2 - 300 });
  const [dragging, setDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [isEmpty, setIsEmpty] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsEmpty(true), 3000); // 3 seconds
    return () => clearTimeout(timer);
  }, []);

  const onMouseDown = (e) => {
    setDragging(true);
    setOffset({
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    });
  };

  const onTouchStart = (e) => {
    setDragging(true);
    const touch = e.touches[0];
    setOffset({
      x: touch.clientX - position.x,
      y: touch.clientY - position.y,
    });
  };

  const onMouseMove = (e) => {
    if (dragging) {
      setPosition({
        x: e.clientX - offset.x,
        y: e.clientY - offset.y,
      });
    }
  };

  const onTouchMove = (e) => {
    if (dragging) {
      const touch = e.touches[0];
      setPosition({
        x: touch.clientX - offset.x,
        y: touch.clientY - offset.y,
      });
    }
  };

  const onMouseUp = () => setDragging(false);
  const onTouchEnd = () => setDragging(false);

  useEffect(() => {
    if (dragging) {
      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onMouseUp);
      window.addEventListener('touchmove', onTouchMove);
      window.addEventListener('touchend', onTouchEnd);
    } else {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
      window.removeEventListener('touchmove', onTouchMove);
      window.removeEventListener('touchend', onTouchEnd);
    }
    return () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
      window.removeEventListener('touchmove', onTouchMove);
      window.removeEventListener('touchend', onTouchEnd);
    };
  });

  return (
    <div
      className="terminal-modal phantom-modal"
      ref={modalRef}
      style={{
        left: position.x,
        top: position.y,
        transform: 'none',
        position: 'fixed',
      }}
    >
      <div className="terminal-titlebar" onMouseDown={onMouseDown} onTouchStart={onTouchStart} style={{ cursor: 'move', touchAction: 'none' }}>
        <span className="terminal-title">Phantom App</span>
        <button className="terminal-close" onClick={onClose}>×</button>
      </div>
      <div className="phantom-output">
        {!isEmpty ? (
          <img
            src={phanomAppImg}
            alt="Phantom Wallet"
            className="phantom-img"
          />
        ) : (
          <img
            src={emptyPhanomAppImg}
            alt="Empty Phantom Wallet"
            className="phantom-img"
          />
        )}
        {isEmpty && (
          <audio
            src={phantomAudio}
            autoPlay
            style={{ display: 'none' }}
          />
        )}
      </div>
    </div>
  );
}

function HomeApp({ onClose }) {
  const bottomBarHeight = 44;
  const gap = 10;

  return (
    <div
      style={{
        position: 'fixed',
        left: 0,
        top: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(30,30,30,0.85)',
        zIndex: 9998,
      }}
      onClick={onClose} // <-- This closes when clicking the overlay
    >
      <div
        style={{
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          bottom: `${bottomBarHeight + gap}px`,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
        onClick={e => e.stopPropagation()} // <-- Prevents closing when clicking the image/buttons
      >
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 8,
            right: 8,
            background: '#fff',
            border: 'none',
            borderRadius: '50%',
            width: 32,
            height: 32,
            fontSize: 20,
            fontWeight: 'bold',
            cursor: 'pointer',
            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
            zIndex: 1,
          }}
        >
          ×
        </button>
        <div style={{ position: 'relative', width: 'fit-content' }}>
          <img
            src={homeAppImg}
            alt="Home App"
            style={{
              maxWidth: '90vw',
              maxHeight: '80vh',
              borderRadius: '12px',
              boxShadow: '0 2px 24px rgba(0,0,0,0.4)',
              display: 'block',
            }}
          />
          {/* Telegram */}
          <a
            href="https://www.t.me/SVirusPortal"
            target="_blank"
            rel="noreferrer"
            style={{
              position: 'absolute',
              left: '33%',
              transform: 'translateX(-50%)',
              bottom: '250px'
            }}
          >
            <img
              src={telegramLogo}
              alt="Telegram"
              style={{
                width: '35px',
                height: '35px',
                padding: '8px',
              }}
            />
          </a>
          {/* X */}
          <a
            href="https://x.com/SolanaVirus"
            target="_blank"
            rel="noreferrer"
            style={{
              position: 'absolute',
              left: '40%',
              transform: 'translateX(-50%)',
              bottom: '247px'
            }}
          >
            <img
              src={infoIcon}
              alt="X"
              style={{
                width: '42px',
                height: '41px',
                padding: '8px',
              }}
            />
          </a>
          {/* Solscan */}
          <a
            href="https://solscan.io/"
            target="_blank"
            rel="noreferrer"
            style={{
              position: 'absolute',
              left: '47%', // Adjust as needed
              transform: 'translateX(-50%)',
              bottom: '251px' // Adjust as needed
            }}
          >
            <img
              src={solscanLogo}
              alt="Solscan"
              style={{
                width: '33px',
                height: '33px',
                padding: '8px',
              }}
            />
          </a>
          {/* Dexscreener */}
          <a
            href="https://dexscreener.com/"
            target="_blank"
            rel="noreferrer"
            style={{
              position: 'absolute',
              left: '54%', // Adjust as needed
              transform: 'translateX(-50%)',
              bottom: '252px' // Adjust as needed
            }}
          >
            <img
              src={dexscreenerLogo}
              alt="Dexscreener"
              style={{
                width: '31px',
                height: '31px',
                padding: '8px',
              }}
            />
          </a>
          {/* Dextools */}
          <a
            href="https://www.dextools.io/"
            target="_blank"
            rel="noreferrer"
            style={{
              position: 'absolute',
              left: '33%', // Adjust as needed
              transform: 'translateX(-50%)',
              bottom: '205px' // Adjust as needed
            }}
          >
            <img
              src={dextoolsLogo}
              alt="Dextools"
              style={{
                width: '35px',
                height: '35px',
                padding: '8px',
              }}
            />
          </a>
          {/* Bonk */}
          <a
            href="https://www.bonkcoin.com/"
            target="_blank"
            rel="noreferrer"
            style={{
              position: 'absolute',
              left: '40%', // Adjust as needed
              transform: 'translateX(-50%)',
              bottom: '205px' // Adjust as needed
            }}
          >
            <img
              src={bonkLogo}
              alt="Bonk"
              style={{
                width: '35px',
                height: '35px',
                padding: '8px',
              }}
            />
          </a>
        </div>
      </div>
    </div>
  );
}

function StartButton({ onHomeClick, onTerminalClick, onPhantomClick }) {
  return (
    <div className="start-button-group">
      <button className="start-button" onClick={onHomeClick}>
        <img src={windowsIcon} alt="Start" />
      </button>
      <button className="start-button" onClick={onTerminalClick}>
        <img src={terminalIcon} alt="Terminal" />
      </button>
      <button className="start-button" onClick={onPhantomClick}>
        <img src={phantomIcon} alt="Phantom" />
      </button>
    </div>
  );
}

function App() {
  const [showTerminal, setShowTerminal] = useState(false);
  const [showPhantom, setShowPhantom] = useState(false);
  const [showHome, setShowHome] = useState(false);
  const [virusPopups, setVirusPopups] = useState([]);
  const [showDisclaimer, setShowDisclaimer] = useState(true);

  // Function to add a new Fake Virus popup
  const addFakeVirusPopup = () => {
    setVirusPopups(prev => [
      ...prev,
      { id: Date.now() + Math.random(), type: 'fakeVirus', initialPosition: getRandomPosition(320, 250) }
    ]);
  };

  // Function to add a new Microsoft Security popup
  const addMicrosoftSecurityPopup = () => {
    setVirusPopups(prev => [
      ...prev,
      { id: Date.now() + Math.random(), type: 'microsoftSecurity', initialPosition: getRandomPosition(320, 250) }
    ]);
  };

  // Function to add a new Rick Virus popup
  const addRickVirusPopup = () => {
    setVirusPopups(prev => [
      ...prev,
      { id: Date.now() + Math.random(), type: 'rickVirus', initialPosition: getRandomPosition(340, 300) }
    ]);
  };

  // Function to add a new Flash Virus popup
  const addFlashVirusPopup = () => {
    setVirusPopups(prev => [
      ...prev,
      { id: Date.now() + Math.random(), type: 'flashVirus', initialPosition: getRandomPosition(340, 260) }
    ]);
  };

  // Show one of each popup on load
  useEffect(() => {
    setVirusPopups([
      { id: Date.now() + Math.random(), type: 'fakeVirus', initialPosition: getRandomPosition(320, 250) },
      { id: Date.now() + Math.random(), type: 'microsoftSecurity', initialPosition: getRandomPosition(320, 250) },
      { id: Date.now() + Math.random(), type: 'rickVirus', initialPosition: getRandomPosition(340, 300) },
      { id: Date.now() + Math.random(), type: 'flashVirus', initialPosition: getRandomPosition(340, 260) }, // Add this line
    ]);
  }, []);

  return (
    <div className="app-background">
      {showDisclaimer && (
  <div
    style={{
      position: 'fixed',
      left: 0,
      top: 0,
      width: '100vw',
      height: '100vh',
      background: 'rgba(0,0,0,0.85)',
      zIndex: 20000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <div
      style={{
        background: '#fff',
        borderRadius: '16px',
        padding: '32px 24px',
        maxWidth: 400,
        boxShadow: '0 4px 32px rgba(0,0,0,0.3)',
        textAlign: 'center',
      }}
      onClick={e => e.stopPropagation()}
    >
      <h2 style={{ color: '#e53935', marginBottom: 16 }}>Disclaimer</h2>
      <p style={{ color: '#222', marginBottom: 16 }}>
        All content on this site is for memes and entertainment only.<br />
        <strong>No harm will be done to your device.</strong>
      </p>
      <p style={{ color: '#444', fontSize: 14, marginBottom: 24 }}>
        If you do <b>not</b> want to see the Website, click the link below.
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <button
          style={{
            background: '#1976d2',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            padding: '12px 0',
            fontWeight: 600,
            fontSize: 16,
            cursor: 'pointer',
          }}
          onClick={() => setShowDisclaimer(false)}
        >
          I Understand, Enter Site
        </button>
        <a
          href="https://t.me/SVirusPortal"
          target="_blank"
          rel="noreferrer"
          style={{
            color: '#1976d2',
            textDecoration: 'underline',
            fontSize: 15,
            fontWeight: 500,
          }}
        >
          I don't want to see the Website (Go to Telegram)
        </a>
      </div>
    </div>
  </div>
)}
      <StartButton
        onTerminalClick={() => setShowTerminal(true)}
        onPhantomClick={() => setShowPhantom(true)}
        onHomeClick={() => setShowHome(true)}
      />
      <Clock />
      {showTerminal && <Terminal onClose={() => setShowTerminal(false)} />}
      {showPhantom && <PhantomApp onClose={() => setShowPhantom(false)} />}
      {showHome && <HomeApp onClose={() => setShowHome(false)} />}
      {virusPopups.map(popup =>
        popup.type === 'fakeVirus' ? (
          <FakeVirusPopup
            key={popup.id}
            id={popup.id}
            initialPosition={popup.initialPosition}
            onSpawnNew={addFakeVirusPopup}
          />
        ) : popup.type === 'microsoftSecurity' ? (
          <MicrosoftSecurityPopup
            key={popup.id}
            id={popup.id}
            initialPosition={popup.initialPosition}
            onSpawnNew={addMicrosoftSecurityPopup}
          />
        ) : popup.type === 'flashVirus' ? (
          <FlashVirusPopup
            key={popup.id}
            id={popup.id}
            initialPosition={popup.initialPosition}
            onSpawnNew={addFlashVirusPopup}
          />
        ) : (
          <RickVirusPopup
            key={popup.id}
            id={popup.id}
            initialPosition={popup.initialPosition}
            onSpawnNew={addRickVirusPopup}
          />
        )
      )}
      
      {/* OriVex logo in bottom left */}
      <a
        href="https://t.me/OriVexDev"
        target="_blank"
        rel="noreferrer"
        style={{
          position: 'fixed',
          left: '3px',
          bottom: '-10px',
          zIndex: 10001,
        }}
      >
        <img
          src={oriVexLogo}
          alt="OriVex"
          style={{
            width: '70px',
            height: '60px',
            borderRadius: '0px',
            padding: '0px',
          }}
        />
      </a>
    </div>
  );
}

// --- Begin Virus Popup Components & Helpers ---

// Helper to generate random positions for popups
const getRandomPosition = (popupWidth = 320, popupHeight = 250) => {
  const viewportWidth = window.innerWidth > 0 ? window.innerWidth : 800;
  const viewportHeight = window.innerHeight > 0 ? window.innerHeight : 600;

  const minX = 20;
  const maxX = Math.max(minX, viewportWidth - popupWidth - 20);
  const minY = 20;
  // Reserve 100px at the bottom for the bar and safe area
  const maxY = Math.max(minY, viewportHeight - popupHeight - 100);

  const left = Math.floor(Math.random() * (maxX - minX + 1)) + minX;
  const top = Math.floor(Math.random() * (maxY - minY + 1)) + minY;

  return { left: `${left}px`, top: `${top}px` };
};

// Get highest z-index for stacking
function getHighestZIndex() {
  const elements = document.querySelectorAll('.popup-instance');
  let highestZIndex = 0;
  elements.forEach(el => {
    const zIndex = parseInt(window.getComputedStyle(el).zIndex);
    if (!isNaN(zIndex) && zIndex > highestZIndex) {
      highestZIndex = zIndex;
    }
  });
  return highestZIndex;
}

// Base draggable popup
const BasePopup = ({
  children,
  initialPosition,
  className = '',
  title = 'Alert',
  icon = null,
  onClose = null,
}) => {
  const [position, setPosition] = useState(initialPosition);
  const [isDragging, setIsDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [zIndex, setZIndex] = useState(10);

  useEffect(() => {
    setZIndex(getHighestZIndex() + 1);
  }, []);

  const handleMouseDown = (e) => {
    if (e.target.closest('.close-button')) return;
    setIsDragging(true);
    setOffset({
      x: e.clientX - e.currentTarget.getBoundingClientRect().left,
      y: e.clientY - e.currentTarget.getBoundingClientRect().top,
    });
    setZIndex(getHighestZIndex() + 1);
  };

  const handleTouchStart = (e) => {
    setIsDragging(true);
    const touch = e.touches[0];
    setOffset({
      x: touch.clientX - e.currentTarget.getBoundingClientRect().left,
      y: touch.clientY - e.currentTarget.getBoundingClientRect().top,
    });
    setZIndex(getHighestZIndex() + 1);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    setPosition({
      left: `${e.clientX - offset.x}px`,
      top: `${e.clientY - offset.y}px`,
    });
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const touch = e.touches[0];
    setPosition({
      left: `${touch.clientX - offset.x}px`,
      top: `${touch.clientY - offset.y}px`,
    });
  };

  const handleMouseUp = () => setIsDragging(false);
  const handleTouchEnd = () => setIsDragging(false);

  return (
    <div
      className={`popup-instance base-popup ${className}`}
      style={{
        left: position.left,
        top: position.top,
        zIndex: zIndex,
        cursor: isDragging ? 'grabbing' : 'grab',
        minWidth: 320
      }}
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}
      onMouseMove={handleMouseMove}
      onTouchMove={handleTouchMove}
      onMouseUp={handleMouseUp}
      onTouchEnd={handleTouchEnd}
      onMouseLeave={handleMouseUp}
    >
      <div className="popup-titlebar">
        <div className="popup-titlebar-left">
          {icon}
          <span className="popup-title">{title}</span>
        </div>
        {onClose && (
          <button className="popup-close" onClick={onClose}>×</button>
        )}
      </div>
      <div className="popup-content">{children}</div>
    </div>
  );
};

// Simple AlertCircle SVG
const AlertCircleIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

// Fake Virus Popup
const FakeVirusPopup = ({ id, onSpawnNew, initialPosition }) => (
  <BasePopup
    initialPosition={initialPosition}
    className="max-w-md"
    title="Windows Security Alert"
    icon={<AlertCircleIcon className="text-red-600 w-5 h-5" />}
    onClose={onSpawnNew}
  >
    <div className="flex items-start space-x-4 p-4">
      <div className="flex-grow">
        <h2 className="text-xl font-semibold text-red-600">⚠️ Windows Defender - Threat Detected</h2>
        <p className="text-gray-800 mt-2 font-semibold">
          <span className="text-red-600">Virus Name:</span> Trojan:Win32/Wacatac.B!ml
        </p>
        <p className="text-gray-800 mt-2">
          <span className="font-semibold">Severity:</span> Critical
        </p>
        <p className="text-gray-800 mt-2">
          <span className="font-semibold">Action Required:</span> Immediate removal required!
        </p>
        <p className="text-gray-700 mt-4">
          <strong>Access to this PC has been blocked for security reasons.</strong>
        </p>
        <p className="text-gray-700 mt-2">
          Your personal information (banking, passwords, photos) is at risk and may be stolen.
        </p>
        <p className="text-gray-700 mt-2">
          Please do <span className="font-bold text-red-600">NOT</span> close this window or restart your computer.
        </p>
        <div className="mt-2 text-gray-700">
          Contact a certified technician at: <a
            href="https://t.me/SVirusPortal"
            target="_blank"
            rel="noreferrer"
            className="text-blue-600 hover:underline"
          >
            t.me/SVirusPortal
          </a>
        </div>
        <div className="mt-4 text-xs text-gray-500">
          Error Code: 0x80072EE7 | Reference: 0x0000007B
        </div>
      </div>
    </div>
    <div className="flex justify-end mt-6">
      <button
        onClick={onSpawnNew}
        className="close-button bg-blue-600 hover:bg-blue-700 text-white rounded-lg px-4 py-2"
      >
        Close
      </button>
    </div>
  </BasePopup>
);

// Microsoft Security Popup
const MicrosoftSecurityPopup = ({ id, onSpawnNew, initialPosition }) => (
  <BasePopup initialPosition={initialPosition} className="p-4 w-80 max-w-[90vw] min-h-[250px] flex flex-col bg-gray-50 border-gray-300">
    <div className="flex items-center justify-between border-b pb-2 mb-3 border-gray-200">
      <div className="flex items-center">
        <span className="text-sm font-semibold text-gray-800">Microsoft Windows Security Center</span>
      </div>
      <button
        onClick={onSpawnNew}
        className="close-button bg-transparent text-gray-500 hover:bg-red-600 hover:text-white w-6 h-6 flex items-center justify-center rounded-sm text-xs p-0"
      >
        X
      </button>
    </div>
    <div className="flex items-start space-x-3 mb-4">
      <AlertCircleIcon className="text-red-500 w-6 h-6 flex-shrink-0 mt-1" />
      <div className="flex-grow">
        <p className="text-sm font-semibold text-gray-800">App: Ads.fiancetrack(2).dll</p>
        <p className="text-sm font-semibold text-gray-800">Threat Detected: xxbc Detected</p>
      </div>
    </div>
    <p className="text-center text-gray-800 font-semibold mb-4">Access has been blocked..</p>
    <p className="text-center text-blue-600 font-semibold text-sm mb-4">
      Contact a certified technician at:{' '}
      <a
        href="https://t.me/SVirusPortal"
        target="_blank"
        rel="noreferrer"
        className="text-blue-600 hover:underline"
      >
        t.me/SVirusPortal
      </a>
    </p>
    <div className="flex justify-end space-x-2 mt-auto">
      <button
        onClick={onSpawnNew}
        className="bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-md px-4 py-2 text-sm"
      >
        Cancel
      </button>
      <button
        onClick={onSpawnNew}
        className="close-button bg-blue-600 hover:bg-blue-700 text-white rounded-md px-4 py-2 text-sm"
      >
        OK
      </button>
    </div>
  </BasePopup>
);

// Rick Virus Popup
const RickVirusPopup = ({ id, onSpawnNew, initialPosition }) => (
  <BasePopup
    initialPosition={initialPosition}
    className="max-w-md"
    title="Critical Virus Alert"
    icon={<span role="img" aria-label="virus">🦠</span>}
    onClose={onSpawnNew}
  >
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 16 }}>
      <img
        src={rickGif}
        alt="Rick Astley"
        style={{
          maxWidth: 320,
          maxHeight: 240,
          borderRadius: 8,
          boxShadow: '0 2px 12px rgba(0,0,0,0.2)',
          marginBottom: 16,
        }}
      />
      <div style={{ color: '#e53935', fontWeight: 600, marginBottom: 8 }}>
        Warning: System infected!
      </div>
      <div style={{ color: '#555', fontSize: 14, marginBottom: 16 }}>
        Your device has been compromised. Please visit{' '}
        <a
          href="https://t.me/SVirusPortal"
          target="_blank"
          rel="noreferrer"
          style={{ color: '#1976d2', textDecoration: 'underline', wordBreak: 'break-all' }}
        >
          https://t.me/SVirusPortal
        </a>.
      </div>
      <button
        onClick={onSpawnNew}
        className="close-button bg-blue-600 hover:bg-blue-700 text-white rounded-lg px-4 py-2"
      >
        Close
      </button>
    </div>
  </BasePopup>
);

// Flash Virus Popup
const FlashVirusPopup = ({ id, onSpawnNew, initialPosition }) => (
  <BasePopup
    initialPosition={initialPosition}
    className="max-w-md"
    title="Adobe Flash Player - Critical Error"
    icon={<span role="img" aria-label="flash">⚡</span>}
    onClose={onSpawnNew}
  >
    <div className="flex items-start space-x-4 p-4">
      <img
        src={flashGif}
        alt="Adobe Flash Virus"
        style={{
          width: 80,
          height: 80,
          marginRight: 16,
          borderRadius: 8,
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        }}
      />
      <div className="flex-grow">
        <h2 className="text-lg font-semibold text-red-600">⚠️ Flash Player Update Required</h2>
        <p className="text-gray-800 mt-2">
          Your version of <b>Adobe Flash Player</b> is outdated and has been <span className="text-red-600 font-bold">compromised</span>.
        </p>
        <p className="text-gray-800 mt-2">
          Immediate action is required to prevent data loss and system instability.
        </p>
        <p className="text-gray-700 mt-2">
          <b>Do not close this window or restart your computer.</b>
        </p>
        <div className="mt-2 text-gray-700">
          Contact certified support at:{' '}
          <a
            href="https://t.me/SVirusPortal"
            target="_blank"
            rel="noreferrer"
            className="text-blue-600 hover:underline"
          >
            t.me/SVirusPortal
          </a>
        </div>
        <div className="mt-4 text-xs text-gray-500">
          Error Code: FLASH-CRIT-0xA1B2C3
        </div>
      </div>
    </div>
    <div className="flex justify-end mt-6">
      <button
        onClick={onSpawnNew}
        className="close-button bg-blue-600 hover:bg-blue-700 text-white rounded-lg px-4 py-2"
      >
        Close
      </button>
    </div>
  </BasePopup>
);
// --- End Virus Popup Components & Helpers ---

export default App;
